import { motion } from 'framer-motion'
import React, { memo, useEffect, useState, useRef } from 'react'
import { Button } from 'react-bootstrap'
import { Container, Stack } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import BootstrapFooter from './BootstrapFooter'

const Footer = () => {
  const { currentUser, logout, userName } = useAuth();
  const location = useLocation();
  const [popupSelected, setPopupSelected] = useState(false);

  useEffect(() => {
    const handlePopUpClickedOut = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        const profile = document.getElementById('profilePopUp')
        profile.classList.remove('active')
        
        if(popupSelected){
          document.removeEventListener('click', handlePopUpClickedOut)
          setPopupSelected(false)
        }
      }
    }
    if(popupSelected)
    {
      document.addEventListener('click', handlePopUpClickedOut)
    }
  })

  const handleOnProfileClick = () => {
    setPopupSelected(true)
    const profile = document.getElementById('profilePopUp')
    profile.classList.toggle('active')
  }

  const profileRef = useRef(null);

  return (
    <>
      <BootstrapFooter></BootstrapFooter>
    </>
  )
}

export default memo(Footer);
